import { AvailabilityQuery } from "./availabilityquery";
import { PassengerType } from "./passengertype";
import { FromJSONable } from "./FromJSONable";
import { ModelRestService } from "../model-rest.service";
import { Route2 } from "./route2";
import { Trip } from "./trip";
import { TranslateService } from '@ngx-translate/core';

export class AvailabilityQuery2 implements FromJSONable{
    constructor(private model:ModelRestService,
        private translate: TranslateService

        
    ){}
    parseJSONObject(object: Object) {
        if(!object){return;}
        Object.assign(this,object);

    }
    public passengers = [0,1,0,0,0];
    public trips:Trip[] = null;
    public round:boolean = false;
    public class:number = 0;
    
    public isReady():boolean{

        if(this.class == null){return false;}
        return true;
    }

    /* Sólo obtiene la suma de pasajeros */
    public getTotalPassengers():number{
        var n:number = 0;
        
        for(var i in this.passengers){
        
            if (+i<4) { 
        
                let n2:number = this.passengers[i];
                n+=n2;                
            }
        }

        return n;
    }

    public getSeatedPassengers():number {
        var result:number;
        for(var i in this.passengers){
            if (+i<3) { 
                let n2:number = this.passengers[i];
                result+=n2;                
            }
        }
        return result;
    }

    public getPassengersString(route:Route2):string{
        var pps:string[] = [];
        for(var i=0;i<route.passenger_types.length;i++){
            let pt:PassengerType = route.passenger_types[i];
            let q:number = this.passengers[pt.id];
            if(q > 0){
                if(pt.name == 'ADULTO'){
                    let p = this.translate.instant('Step1-P92');
                    pps.push(p +": "+q);
                }else if(pt.name == 'MENOR'){
                    let p = this.translate.instant('Step1-P93');
                    pps.push(p +": "+q);
                }else if(pt.name == 'INFANTE'){
                    let p = this.translate.instant('Step1-P94');
                    pps.push(p +": "+q);
                }
                else if(pt.name == 'ADULTO MAYOR'){
                    let p = this.translate.instant('Step1-P97');
                    pps.push(p +": "+q);
                }
            }
        }
        return pps.join(", ");
    }

    public toAvailabilityQuery(route:Route2):AvailabilityQuery{
        var availabilityQuery:AvailabilityQuery = new AvailabilityQuery();
        availabilityQuery.round = this.round;
        availabilityQuery.id_class = this.class;
        availabilityQuery.trips = this.trips;
        availabilityQuery.a=this.passengers[1];
        availabilityQuery.m=this.passengers[2];
        availabilityQuery.am=this.passengers[3];
        availabilityQuery.i=this.passengers[4];
      
        return availabilityQuery;
    }

}